/**
 * Processes JSON data to extract keys and the number of items.
 *
 * @param {String} jsonText - The JSON data as a string.
 * @return {Object} An object containing the keys and the number of items.
 */
const processJSON = jsonText => {
	const jsonData = JSON.parse( jsonText );

	if ( ! Array.isArray( jsonData ) ) {
		throw new Error( 'JSON data is not an array' );
	}

	const keys = jsonData.reduce( ( acc, item ) => {
		Object.keys( item ).forEach( key => acc.add( key ) );
		return acc;
	}, new Set() );

	const numberOfItems = jsonData.length;

	return {
		type: 'json',
		keys: Array.from( keys ),
		numberOfItems: numberOfItems
	};
}

export default processJSON;
